<div id="navtree">

  <!-- Global Device Search -->
  <label class="sr-only" for="searchDevices">Search All Devices</label>
  <div class="input-group mb-2 mr-sm-2 search-field">
    <button type="button" class="input-group-text" (click)="overlay.toggle($event)" pButton icon="fas fa-search" label=""
    style="padding-top: 3.25px; padding-bottom: 3.25px; margin: 0px 0px 0px 0px !important;"></button>
    <input type="text" [(ngModel)]="searchText" (keyup)="searchDevices($event)" class="form-control search-box" id="searchDevices" placeholder="Search All Devices...">
    <p-overlayPanel #overlay [showCloseIcon]="true" [style]="{ 'background-color': 'lightgrey' }">
      <div class="search-overlay">
        <select class="" [(ngModel)]="searchType">
          <option value="contains" selected>Contains</option>
          <option value="exact">Exact</option>
          <option value="prefix">Prefix</option>
          <option value="suffix">Suffix</option>
        </select>

        <button type="button" class="" (click)="overlay.toggle($event); searchDevices()" pButton label="Search"
          style="padding-top: 3.25px; padding-bottom: 3.25px; margin: 0px 0px 0px 0px !important;"
          [disabled]="!enableSearchButton">
        </button>
      </div>
    </p-overlayPanel>
  </div>

  <!-- Network Filter -->
  <label class="sr-only" for="filterNetworks">Filter Networks</label>
  <div class="input-group mb-2 mr-sm-2 search-field">
    <i class="fa fa-filter search-icon input-group-text"></i>
    <input type="text" [(ngModel)]="filter" (keyup)="filterNetworks()" class="form-control search-box" id="filterNetworks" placeholder="Filter Networks...">
  </div>

  <div style="height: 20px;"></div>

  @if (!isObserver) {
    <div>
      <div>
        <span class="network-header" [routerLink]="'/networks'">My Networks</span>
        <!--<button type="button" (click)="showNewNetworkDialog()" [disabled]="!isLicenseValid" pButton icon="fa fa-plus-square-o" label="New" class="add-button"></button>-->
      </div>
      @if (!hasNetworks) {
        <div class="no-networks">None</div>
      }
      <!-- Network List-->
      <div class="my-networks" [style.height]="myNetworksHeight">
        @if (hasNetworks) {
          <p-scrollPanel styleClass="navtree-network-list">
            <ul class='nav navbar-nav'>
              @for (network of filteredNetworks; track network) {
                <li>
                  <a>
                    <span class="network-name" (click)="onNetworkClick(network)">{{network.Name}}</span>
                    <p-menu [appendTo]="body" #menu [popup]="true" [model]="netViewItems(network.Guid)"></p-menu>
                    <i #showSubNavButton class="fa-solid fa-caret-right sub-nav-arrow"
                    (click)="showSubNav(network, showSubNavButton.getBoundingClientRect().right, showSubNavButton.getBoundingClientRect().bottom)"></i>
                  </a>
                </li>
              }
            </ul>
          </p-scrollPanel>
        }
      </div>
    </div>
  }

  <div style="height: 20px;"></div>

  @if (!isAdmin) {
    <div>
      <p>
        <span class="network-header" [routerLink]="'/networks'">Networks Shared With Me</span>
      </p>
      @if (!hasShares) {
        <div class="no-networks">None</div>
      }
      <!-- Shared Networks List-->
      <div class="shared-networks" [style.height]="sharedNetworksHeight">
        @if (hasShares) {
          <p-scrollPanel styleClass="navtree-network-list">
            <ul class='nav navbar-nav'>
              @for (share of filteredShares; track share) {
                <li>
                  <a>
                    <span class="network-name" (click)="onNetworkClick(share.network)">{{share.network.Name}}</span>
                    <p-menu [appendTo]="body" #menu [popup]="true" [model]="shareItems(share.share.Guid)"></p-menu>
                    <i #showSubNavButton class="fa-solid fa-caret-right sub-nav-arrow"
                    (click)="showSubNav(share.network, showSubNavButton.getBoundingClientRect().right, showSubNavButton.getBoundingClientRect().bottom)"></i>
                  </a>
                </li>
              }
            </ul>
          </p-scrollPanel>
        }
      </div>
    </div>
  }

  <!-- Sub Nav-->
  @if (displaySubNav) {
    <div id="subnav" class="sub-nav" style="padding-left: 20px; padding-right: 10px; border: 3px solid #444;">
      <button type="button" pButton class="close"
      icon="fa fa-times-circle fa-1" (click)="closeDialogues()"></button>
      <ul class="nav navbar-nav">
        <li>
          <span class="navbar-text subnav-header">
            {{subNavContext.title}}
          </span>
        </li>
      </ul>
      <p-scrollPanel styleClass="navtree-subnav-list">
        <ul class='nav navbar-nav'>
          @for (item of subNavContext.items; track item) {
            <li>
              <a>
                <span (click)="onSubNavItemClick(item)">{{item.label}}</span>
                <p-menu [appendTo]="body" #menu [popup]="true" [model]="item.menuItems"></p-menu>
                <i class="fa-solid fa-caret-right sub-nav-arrow" (click)="onSubNavDrillDown(item)"></i>
              </a>
            </li>
          }
        </ul>
      </p-scrollPanel>
    </div>
  }

</div>


<confirmation-dialog message="Are you sure you want to delete this network?"
  [display]="displayDeleteNetViewConfirm"
  (onYes)="deleteNetView()" (onNo)="cancelDeleteNetView()">
</confirmation-dialog>


<confirmation-dialog message="Are you sure you want to delete this agent?"
  [display]="displayDeleteAgentConfirm"
  (onYes)="deleteAgent()" (onNo)="cancelDeleteAgent()">
</confirmation-dialog>


<confirmation-dialog message="Are you sure you want to delete this discovery?"
  [display]="displayDeleteDiscoveryConfirm"
  (onYes)="deleteDiscovery()" (onNo)="cancelDeleteDiscovery()">
</confirmation-dialog>


<new-network-dialog [display]="displayNewNetworkDialog"
  (onClose)="onNewNetworkDialogClose()">
</new-network-dialog>


<new-agent-dialog [display]='displayNewAgentDialog'
  [parent]='subNavContext.network'
  (onSuccess)='onAgentCreated()'
  (onClose)='onNewAgentDialogClose()'>
</new-agent-dialog>


<new-discovery-dialog [display]="displayNewDiscoveryDialog"
  [parent]="subNavContext.agent"
  (onSuccess)="onDiscoveryCreated()"
  (onClose)="onNewDiscoveryDialogClose()">
</new-discovery-dialog>

<share-source-dialog [(display)]="displaySourceSharingDialog" [sharedItemGuid]="sourceSharedItemGuid"></share-source-dialog>

<share-target-dialog [(display)]="displayTargetSharingDialog" [sharedItemGuid]="targetSharedItemGuid"></share-target-dialog>

<device-search [(visible)]="searchResultVisible" [deviceList]="searchResult?.entries" (deviceSelected)="onSearchDeviceSelected($event)"></device-search>

<device-details #devicedetails [selectedDevice]="selectedSearchDevice" [isMasterDevice]="true"></device-details>

<!-- Offcanvas element for details-->
<ng-template #detailsOffCanvas let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title" id="offcanvas-basic-title">Details</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
  </div>
  <div class="offcanvas-body">
    <form>
      <div class="mb-3">
        <info-sets #infosets [selectedDevice]="selectedDevice"></info-sets>
      </div>
    </form>
  </div>
</ng-template>
